export default __webpack_public_path__ + "static/media/Directory.8c89f1d6.svg";